import _ from 'lodash'

import {
  FETCH_CONFIG_BEGIN,
  FETCH_CONFIG_SUCCESS,
  FETCH_CONFIG_ERROR,
} from '../actions/fetchConfiguration'

const initialState = {
  loading: false,
  error: null,
  data: null,
}

export default function fetchConfiguration(state = initialState, action) {
  switch (action.type) {
    case FETCH_CONFIG_BEGIN:
      return Object.assign({}, state, {
        loading: true,
      })
    case FETCH_CONFIG_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        data: action.payload,
      })
    case FETCH_CONFIG_ERROR:
      return Object.assign({}, state, {
        loading: false,
        error: action.payload,
      })
    default:
      return state
  }
}

export const configurationData = (state) => state.configurationData
export const getBrand = (state) => _.get(state, 'configurationData.data.brand')
export const getDisplayBookButtons = (state) =>
  _.get(state, 'configurationData.data.displayBookButtons')
export const getPricingComment = (state) =>
  _.get(state, 'configuration.data.pricingComment') ||
  'The following is from pricing per person.'
export const getShouldDisplayEasyQuoteButton = (state) =>
  !_.has(state, 'configurationData.data.hideEasyQuote') ||
  !_.get(state, 'configurationData.data.hideEasyQuote')
export const getPurlButtonInfo = (state) => {
  const purlCta = _.get(state, 'configurationData.data.purlCta')
  const purlUrl = _.get(state, 'configurationData.data.purlUrl')
  return purlCta && purlUrl
    ? {purlCta, purlUrl}
    : null
}
